<template>
  <RightSideBar @close="$emit('close')" button-class="bg-dynamicBackBtn text-white" :submit="'Save'" :cancel="'Cancel'" :loading="isLoading" @submit="submit" :disabled-button="isLoading">
    <template v-slot:title>
      <div class="text-darkPurple flex gap-5 items-center">
        <div class=""  @click="closeSidebar()"><icon icon-name="back_arrow" size="s" class="w-8 h-8 rounded text-romanSilver"/></div> Access List
      </div>
    </template>
    <p class="font-normal text-sm text-darkPurple">
      View all employees who have access to this file.
    </p>

    <div class="w-full" v-if="usersAccessList.length > 0">
      <div 
        v-for="(user, index) in usersAccessList" :key="index"
        class="w-full h-14 p-3 flex flex-row justify-between items-center border-bottom relative"
      >
        <div class="h-8 flex justify-start items-start gap-1">
          <img :src="user.accessUser.photo" alt="" v-if="user.accessUser.photo" class="w-8 h-8">
          <div v-else class="w-8 h-8 flex justify-center items-center rounded text-blueCrayola border text-center font-semibold">
            {{ user.accessUser.fname ? $getInitials(`${user.accessUser.fname} ${user.accessUser.lname}`) : ""}} 
          </div>
          <div>
            <p class="text-sm text-darkPurple">
              {{ user.accessUser.fname ? `${user.accessUser.fname} ${user.accessUser.lname}` : "-" }}
            </p>
            <p class="text-xs text-romanSilver uppercase font-bold">
              {{ user.accessUser.orgFunction && user.accessUser.orgFunction.name ? user.accessUser.orgFunction.name : "-" }}
            </p>
          </div>
        </div>
        <div class="w-28 h-8">
          <p class="payInfo payInfo_fakeInput text-romanSilver w-full capitalize">{{ user.access }}</p>
        </div>  
      </div>
    </div>
  </RightSideBar>
  </template>
  
  <script>
  import RightSideBar from "../RightSideBar";
  import Card from "../Card";
  import CSelect from "@scelloo/cloudenly-ui/src/components/select"
  
  export default {
    name: "AccessList",
    components: {
      RightSideBar,
      CSelect,
      Card
    },
    props: {
      item: {
        type: Object,
        default: () => ({})
      },
      people: {
        type: Array,
        default: () => ([])
      },
      currentTab: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        isLoading: false,
        accessUsers: []
      };
    },
    computed: {
      usersAccessList(){
        return this.accessUsers;
      }
    },
    methods: {
      closeSidebar() {
        this.$emit('close');                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
      },     
      getAccessUserIds(){
        this.accessUsers.forEach(user => {
          const matchingObject = this.people.find(el => el.id === user?.accessUser.id);
          
          if (matchingObject) {
            user.accessUser.userId = matchingObject.userId;
          }
        });
      },                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
      async submit() {     
        this.getAccessUserIds();                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            
           
        const usersAccess = this.accessUsers.map(user => ({
          userId: user.accessUser.userId,         
          access: user.access.toLocaleLowerCase() 
        }));  

        const payload = {
          userAccess: usersAccess
        };
        this.isLoading = true;
        
        try {
          await this.$_updatePermissions(this.currentTab.toLowerCase().includes('folders') ? this.item.folderId : this.item.fileId, payload, this.currentTab.toLowerCase().includes('folders') ? 'folders' : 'files');
          this.closeSidebar();
          return this.$toasted.success("Users permissions successfully updated", {duration: 6000});
        } catch (error) {
          console.log(error, "error")
          this.isLoading = false;
          return this.$toasted.error("Erorr updating users access permissions", {duration: 6000});
        }
      },
    },
    mounted() {
      if(this.currentTab.toLowerCase().includes('folders')){
        this.accessUsers = this.item.folderPermissions[0].permissionUsers.map(permissionUser => ({
        ...permissionUser,
        access: this.item.folderPermissions[0].access
      }));
      }
      if(this.currentTab.toLowerCase().includes('files')){
        this.accessUsers = this.item.filePermissions[0].permissionUsers.map(permissionUser => ({
          ...permissionUser,
          access: this.item.filePermissions[0].access
        }));
      }
    },
  };
  </script>
  
<style scoped>
.payInfo_fakeInput {
  background-color: #EEEEEE;
  height: 32px;
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border: 1px solid #878E99;
  border-radius: 5px;
}
.border-bottom{
  border-bottom: 1px solid #00000029 !important
}
</style>
  